import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ArrowCircle = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 2.5V6M13.5 6H10M13.5 6C13 4.83333 11.2 2.5 8 2.5C4 2.5 2.5 6 2.5 7.5M2.5 13.5V10M2.5 10H6M2.5 10C3 11.1667 4.8 13.5 8 13.5C12 13.5 13.5 10 13.5 8.5"
        stroke={color}
      />
    </svg>
  ),
)

ArrowCircle.displayName = 'ArrowCircle'

ArrowCircle.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default ArrowCircle
